import { render, staticRenderFns } from "./TouristicObjectFormCard.vue?vue&type=template&id=2584dd48&"
import script from "./TouristicObjectFormCard.vue?vue&type=script&lang=js&"
export * from "./TouristicObjectFormCard.vue?vue&type=script&lang=js&"
import style0 from "./TouristicObjectFormCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports